import { createNegativation, updatePaymentNegativation } from "@/common/services/renter-negativation.api";
import { PaymentsNegativation } from "./paymentCalculations.helper";
import { PaymentDeleted } from "@/types/renters-negativation.type";

export interface NegativationRequestData {
  id: string[];
  walletId: string;
  externalPaymentIds: (string | undefined)[];
  description: string[];
  value: number[];
  splitValue: string;
  splitPercentualValue: number;
  totalValue: number;
  renterId: string | undefined;
  paymentSelecteds: PaymentDeleted[];

}

export interface TotalRowData {
  description: string;
  value: string;
  split: string;
  splitValue: string;
  splitPercentualValue: string;
}

export interface NegativationCallbacks {
  onLoadingStart: () => void;
  onLoadingEnd: () => void;
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
  onUpdateSuccess?: () => void;
}

export const submitNegativation = async (
  data: NegativationRequestData,
  callbacks: NegativationCallbacks
): Promise<boolean> => {
  try {
    callbacks.onLoadingStart();

    const result = await createNegativation(data);

    if (!result.ok) {
      callbacks.onError(result.message || "Erro ao criar negativação.");
      return false;
    }

    callbacks.onSuccess("Negativação criada com sucesso.");
    return true;
  } catch (error) {
    console.error("Erro ao enviar os pagamentos:", error);
    callbacks.onError("Erro inesperado ao criar negativação.");
    return false;
  } finally {
    callbacks.onLoadingEnd();
  }
};


export const updatePayment = async (
  data: NegativationRequestData,
  callbacks: NegativationCallbacks
): Promise<boolean> => {
  try {
    callbacks.onLoadingStart();

    const result = await updatePaymentNegativation(data);

    if (!result.ok) {
      callbacks.onError(result.message || "Erro ao atualizar pagamento.");
      return false;
    }

    // Callback específico para sucesso de update
    if (callbacks.onUpdateSuccess) {
      callbacks.onUpdateSuccess();
    }

    callbacks.onSuccess("Pagamento atualizado com sucesso.");
    return true;
  } catch (error) {
    console.error("Erro ao atualizar pagamento:", error);
    callbacks.onError("Erro inesperado ao atualizar pagamento.");
    return false;
  } finally {
    callbacks.onLoadingEnd();
  }
};


export const prepareNegativationData = (
  selectedPayments: PaymentsNegativation[],
  totalRow: TotalRowData,
  walletId: string,
  renterId: string | undefined
): NegativationRequestData => {

  // Criar o array de objetos paymentSelecteds
  const paymentSelecteds: PaymentDeleted[] = selectedPayments.map(payment => ({
    description: payment.description,
    externalPaymentId: payment.externalPaymentId || '',
    value: payment.value
  }));

  return {
    id: selectedPayments.map(payment => payment._id),
    walletId,
    externalPaymentIds: selectedPayments.map(payment => payment.externalPaymentId),
    description: selectedPayments.map(payment => payment.description),
    value: selectedPayments.map(payment => payment.value),
    splitValue: totalRow.splitValue,
    splitPercentualValue: parseFloat(totalRow.splitPercentualValue),
    totalValue: parseFloat(totalRow.value.replace(/[R$\s.]/g, '').replace(',', '.')),
    renterId: renterId,
    paymentSelecteds: paymentSelecteds, // ✅ Incluir o array de objetos
  };
};
